import { AutogenModelEdimonitorZbfrloc, AutogenRowEdimonitorZbfrloc } from "./autogen/AutogenModelEdimonitorZbfrloc";

export class ModelEdimonitorZbfrloc extends AutogenModelEdimonitorZbfrloc<RowEdimonitorZbfrloc> {
	constructor() {
		super(RowEdimonitorZbfrloc);
	}
}

export class RowEdimonitorZbfrloc extends AutogenRowEdimonitorZbfrloc {
}